module.exports = __webpack_public_path__ + "media/app/assets/specializations/rogue/assassination-e9651120b593b2f4e52cfb7761487460.png";